import { render, staticRenderFns } from "./DrawerRight.vue?vue&type=template&id=07b9f62d&"
import script from "./DrawerRight.vue?vue&type=script&lang=js&"
export * from "./DrawerRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports